import AjaxService from '@services/AjaxService';
import BaseRepository from '@repositories/desktop/BaseRepository';

export default class AnnouncementRepository extends BaseRepository {
  protected baseUrl = '/api/desktop/announcements';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public confirmAnnouncements(url: string, announcementIds: any[]): Promise<any> {
    return this.ajaxService.getJsonWithParameters(url, {announcementIds});
  }

  public create(attributes: any): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}/create`, {data: {attributes}});
  }

  public delete(id: number): Promise<any> {
    return this.ajaxService.sendDelete(`${this.baseUrl}/${id}/delete`);
  }

  public getBlank(): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/blank`);
  }

  public loadFirmAssociationOptions(): Promise<any> {
    return this.loadSelectOptions(`${this.baseUrl}/firm-association/options`);
  }

  public loadFirmGroupOptions(): Promise<any> {
    return this.loadSelectOptions(`${this.baseUrl}/firm-group/options`);
  }

  public loadFirmOptions(): Promise<any> {
    return this.loadSelectOptions(`${this.baseUrl}/firm/options`);
  }

  public preview(attributes: {announcementHtml: string; announcementId?: number; uploadSessionId?: string}): Promise<any> {
    return this.ajaxService.postJson(`${this.baseUrl}/preview`, {data: {attributes}});
  }

  public saveBasedata(id: number, attributes: any): Promise<any> {
    return this.ajaxService.postJson(
      `${this.baseUrl}/${id}/basedata/save`,
      {data: {attributes}}
    );
  }

  public show(id: number): Promise<any> {
    return this.ajaxService.getJson(`${this.baseUrl}/${id}`);
  }
}
